import * as React from 'react';
import { H4 } from '@frontend/shadcn/components/typography/h4';
import { AccordionTrigger, AccordionItem, Accordion, AccordionContent } from '@frontend/shadcn/components/ui/accordion';
import { Small } from '@frontend/shadcn/components/typography/small';
import { Col, Row } from 'antd-v5';
import { FormAsyncAction, IShopifyPromoCodeFormOptions, IShopifyPromoCodeFormValues, OfferFormModes, TDisabledMap, TFormValues } from '../../../types';
import { BoostListing } from './BoostListing';

interface IProps {
    values: TFormValues,
    mode: OfferFormModes,
    onFinish?: () => void,
    requiredFields: React.ReactNode,
    handleFormAsyncActions?: (value: FormAsyncAction) => void,
    formOptionsData?: IShopifyPromoCodeFormOptions,
    isSubscriptionEnable: boolean,
    disabledShopify: TDisabledMap<IShopifyPromoCodeFormValues>;
}

const Boosts = ({ values, mode, onFinish, requiredFields, handleFormAsyncActions, formOptionsData, isSubscriptionEnable, disabledShopify }: IProps): JSX.Element => {
  return (
    <Accordion type="single" collapsible className="w-full" title="Boosts">
      <AccordionItem value="item-1" className="border-0 m-0">
        <AccordionTrigger className="hover:no-underline p-0 m-0">
          <Col>
            <Row>
              <H4 className="mb-0">Boosts</H4>
            </Row>
            <Row>
              <Small>Create additional incentives to encourage influencers.</Small>
            </Row>
          </Col>
        </AccordionTrigger>
        <AccordionContent>
          <Row>
            <BoostListing values={values} mode={mode} onFinish={onFinish} requiredFields={requiredFields} handleFormAsyncActions={handleFormAsyncActions} formOptionsData={formOptionsData} isSubscriptionEnable={isSubscriptionEnable} disabledShopify={disabledShopify} />
          </Row>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default Boosts;
